import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'
import styled from 'styled-components'

export const DashboardContainer = styled.div`
  padding: 32px;
  background: #f4f4f4;
  min-height: calc(100vh - 64px);
  overflow-y: auto;
  height: calc(100vh - 64px);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`

export const Title = styled(Typography)`
  font-weight: 600;
  color: ${({ theme }) => theme.black?.main || '#111111'};
`

export const LoadingContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 400px;
  gap: 16px;
`

export const MetricCard = styled(Paper)`
  padding: 24px;
  background: white;
  border-radius: 16px;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.primary?.main || '#EEEDED'};
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const MetricLabel = styled(Typography)`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.fieldLabel?.main || '#7D7D7D'};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const MetricValue = styled(Typography)`
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.black?.main || '#111111'};
  line-height: 1.1;
`

export const MetricHint = styled(Typography)`
  font-size: 12px;
  color: ${({ theme }) => theme.fieldLabel?.main || '#7D7D7D'};
`

export const FilterCard = styled(Paper)`
  padding: 16px 20px;
  margin-bottom: 24px;
  background: white;
  border-radius: 16px;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.primary?.main || '#EEEDED'};
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
`

export const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 12px;

    &:hover fieldset {
      border-color: ${({ theme }) => theme.link?.main || '#0074FE'};
    }

    &.Mui-focused fieldset {
      border-color: ${({ theme }) => theme.link?.main || '#0074FE'};
    }
  }
`

export const TableCard = styled(Paper)`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.primary?.main || '#EEEDED'};
`

export const BreakdownPanel = styled.div`
  padding: 16px 24px 24px 56px;
  background: #fafbfc;
  border-top: 1px dashed ${({ theme }) => theme.primary?.main || '#EEEDED'};
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const BreakdownRow = styled.div`
  display: flex;
  gap: 16px;
  font-size: 14px;

  & > span:first-child {
    min-width: 200px;
    color: ${({ theme }) => theme.fieldLabel?.main || '#7D7D7D'};
  }

  & > span:last-child {
    color: ${({ theme }) => theme.black?.main || '#111111'};
    font-weight: 500;
  }
`

export const StatusBadge = styled(Chip)`
  font-weight: 600;
  font-size: 12px !important;
  height: 24px !important;
`

export const EmptyState = styled.div`
  padding: 48px;
  text-align: center;
  color: ${({ theme }) => theme.fieldLabel?.main || '#7D7D7D'};
`

export const EmptyStateFilters = styled.div`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 16px;
  font-size: 13px;

  & b {
    color: ${({ theme }) => theme.black?.main || '#111111'};
    font-weight: 600;
  }
`

export const MutedCell = styled.span`
  color: #b0b0b0;
`
